import { ref, computed } from "vue";
import { useRoute, useRouter } from "vue-router";

export function usePagination() {
  const route = computed(() => useRoute());
  const { replace } = useRouter();
  const query = route.value.query;
  const queryPage = isNaN(query.page) ? 1 : +query.page;
  const queryItemPerPage = isNaN(query.itemPerPage) ? 10 : +query.itemPerPage;

  const page = ref(queryPage);
  const itemPerPage = ref(queryItemPerPage);

  const setPagination = (newPage, newItemPerPage) => {
    page.value = newPage;
    itemPerPage.value = newItemPerPage;
    replace({ query: { page: page.value, itemPerPage: itemPerPage.value } });
  };

  return { page, itemPerPage, setPagination };
}
